export default "__VITE_ASSET__436ad923__"